import actions from 'actions'

const defaultState = {
  dropdownOpen: false,
}

export default function navigation(state = defaultState, action) {
  const { type } = action

  switch (type) {
    case actions.NAVIGATION_DROPDOWN_TOGGLE:
      return {
        dropdownOpen: !state.dropdownOpen,
      }
    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/navigation/navigation.js
 **/